import React from "react";
import { motion } from "framer-motion";

function AIActionButton({
  children,
  loading = false,
  isDark = false,
  style = {},
  ...props
}) {
  return (
    <motion.button
      whileHover={{
        y: -2,
        scale: 1.01,
      }}
      whileTap={{
        scale: 0.985,
      }}
      transition={{
        type: "spring",
        stiffness: 320,
        damping: 20,
      }}
      style={{
        position: "relative",
        overflow: "hidden",
        padding: "13px 18px",
        borderRadius: "14px",

        border: isDark
          ? "1px solid rgba(255,255,255,0.08)"
          : "1px solid rgba(15,23,42,0.08)",

        background:
          style.background ||
          (isDark
            ? "#e2e8f0"
            : "#111827"),

        color:
          style.color ||
          (isDark
            ? "#020617"
            : "#ffffff"),

        fontWeight: 700,

        cursor: loading
          ? "not-allowed"
          : "pointer",

        boxShadow: isDark
          ? "0 10px 30px rgba(15,23,42,0.22)"
          : "0 10px 30px rgba(15,23,42,0.12)",

        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",

        backdropFilter: "blur(12px)",
        WebkitBackdropFilter:
          "blur(12px)",

        transition:
          "all 180ms ease",

        opacity: loading
          ? 0.72
          : 1,

        ...style,
      }}
      disabled={loading}
      {...props}
    >
      <motion.div
        initial={{
          x: "-120%",
        }}
        animate={{
          x: "120%",
        }}
        transition={{
          duration: 2.8,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          inset: 0,

          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent)",

          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      <span
        style={{
          position: "relative",
          zIndex: 2,
        }}
      >
        {loading
          ? "Generating..."
          : children}
      </span>
    </motion.button>
  );
}

export default AIActionButton;